import type { RenderCallback } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import React, { useCallback } from 'react';

import LoadableGroupCreateModal from '../LoadableGroupCreateModal';

type UseGroupCreateModal = (
  isCopilotAdoptionModal?: boolean,
  isCopilotAdoptionCommunityAdminFREEnabled?: boolean
) => ReturnType<typeof useRenderToggleableContent>;
export const useGroupCreateModal: UseGroupCreateModal = (
  isCopilotAdoptionModal = false,
  isCopilotAdoptionCommunityAdminFREEnabled = false
) => {
  const renderCallback: RenderCallback = useCallback(
    ({ hideContent }) => (
      <LoadableGroupCreateModal
        onDismiss={hideContent}
        isCopilotAdoptionModal={isCopilotAdoptionModal}
        isCopilotAdoptionCommunityAdminFREEnabled={isCopilotAdoptionCommunityAdminFREEnabled}
      />
    ),
    [isCopilotAdoptionModal, isCopilotAdoptionCommunityAdminFREEnabled]
  );

  return useRenderToggleableContent(renderCallback);
};

type UseCopilotAdoptionGroupCreateModal = () => ReturnType<typeof useRenderToggleableContent>;
export const useCopilotAdoptionGroupCreateModal: UseCopilotAdoptionGroupCreateModal = () =>
  useGroupCreateModal(true, true);

type UseCopilotAdminFREModal = () => ReturnType<typeof useRenderToggleableContent>;
export const useCopilotAdminFREModal: UseCopilotAdminFREModal = () => useGroupCreateModal(true, true);

export default useGroupCreateModal;
